import { useCallback } from 'react';
import { useNavigateToCampaignDetail } from './useNavigateToCampaignDetail';
import { useNavigateToCommunityDetail } from './useNavigateToCommunityDetail';
import { useNavigateToEventDetail } from './useNavigateToEventDetail';
import { useNavigateToProgramDetail } from './useNavigateToProgramDetail';

export const useNavigateToEntityDetail = () => {
  const navigateToCommunityDetail = useNavigateToCommunityDetail();
  const navigateToProgramDetail = useNavigateToProgramDetail();
  const navigateToEventDetail = useNavigateToEventDetail();
  const navigateToCampaignDetail = useNavigateToCampaignDetail();

  return useCallback(
    (
      id: string,
      options: { entityType: 'campaign'; organizationId: string } | { entityType: 'community' | 'event' | 'program' },
    ) => {
      const { entityType } = options;

      if (entityType === 'community') {
        navigateToCommunityDetail(id);
      }

      if (entityType === 'program') {
        navigateToProgramDetail(id);
      }

      if (entityType === 'event') {
        navigateToEventDetail(id);
      }

      if (entityType === 'campaign') {
        const { organizationId } = options;
        navigateToCampaignDetail(id, organizationId);
      }
    },
    [navigateToCampaignDetail, navigateToCommunityDetail, navigateToEventDetail, navigateToProgramDetail],
  );
};
